import {useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable"
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown"
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs"
import { useGetOrganogramLogs, useGetOrganogramStatus, useGetOrganogramTypes, useResetOrganogramLog } from "./hooks/useFTP";


const DataChange = () => {
    
    const [filterData,setFilterData] = useState({
            page:1,
            limit:10,
            search:'',   // Replace with  handleSerachInput value
            status:'',
            actionType:'',
            requestedData:'',
            filePath:'',
            sortColumn:'',
        })

    // API 
    const{mutate:resetOrganogramLog} = useResetOrganogramLog();
    const {data:organogramTypes, isLoading:organogramTypesLoading, isSuccess:organogramTypesTypes } = useGetOrganogramTypes({enable:true})
    const {data:StatusDropDownData, isLoading:StatusDropDownLoading, isSuccess:StatusDropDownSuccess}  = useGetOrganogramStatus({enable:true})


  const ActionTypeDropDown = !organogramTypesLoading && organogramTypes?.data
  ? [
        {id:'', label: 'All' },
        ...Object.entries(organogramTypes.data).map(([id, label]) => ({
            id,
            label
        }))

  ] :[]



const StatusDropDown = !StatusDropDownLoading && StatusDropDownSuccess && StatusDropDownData?.data
  ? [
      {id:'', label: 'All' }, 
      ...Object.entries(StatusDropDownData.data).map(([id, label]) => ({
        id,
        label
      }))
    ]
  : [];

    const {data,isLoading,isSuccess} = useGetOrganogramLogs({enable:true,params:{
        page:filterData.page,
        limit:filterData.limit,
        search:filterData.search,
        status:filterData.status,
        actionType:filterData.actionType,
        requestedData:'',
        filePath:'',
        sortColumn:'',
    }})


   const DataForOrganogramLogs = !isLoading && isSuccess && data?.data?.organogramLogs?.map((item:any)=>(
    {
        id : item?.DataChangeRequestId || null,
        filePath: item?.ImportFilePath || '-',
        data:item?.RequestedData || '-',
        actionType:item?.ActionType ||'-',
        date:item?.ScheduleDate || '-',
        status:item?.Status || '-',
        error:item?.HasError || '-',
        errorMsg:item?.ErrorMessage || '-',
    }
   ))

//    console.log('DataForOrganogramLogs',DataForOrganogramLogs);

  const dataChange = (handleReset: (row: any) => void) => [
        {
            name: "ID",
            selector: (row: { id: number | string }) => row.id,
            sortable: true,
            width: '70px'
        },
        {
            name: "File Path",
            selector: (row: { filePath: string }) => row.filePath,
            sortable: true,
            wrap:true,
            width: '250px',

        },
        {
            name: "Data",
            selector: (row: { data: string }) => row.data,
            sortable: true,
            width: '350px',
            wrap: true,

        },
        {
            name: "Action Type",
            selector: (row: { actionType: string }) => row.actionType,
            sortable: true,
            wrap:true,
            minWidth:'250px'
        },

        {
            name: "Date",
            selector: (row: { date: string }) => row.date,
            sortable: true,
            minWidth:'140px',
        },
        {
            name: "Status",
            selector: (row: { status: string }) => row.status,
            sortable: true,
        },
        {
            name: "Error",
            selector: (row: { error: string }) => row.error,
            sortable: true,
        },
        {
            name: "Error Message",
            selector: (row: { errorMsg: string }) => row.errorMsg,
            sortable: true,
            wrap:true,
            minWidth:'200px',
        },

        {
            name: "Actions",
            cell: (row: any) => (
                <button
                    onClick={() => handleReset(row)}
                    className="btn btn-primary"
                    style={{
                        borderRadius: "20px",
                        padding: "5px",
                        width: "55px",
                        height: "25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                    }}
                >
                    Reset
                </button>
            ),
        },
    ];

  const handleActionTypeRquest =(value:any)=>{

        const label: string = value.id;
        setFilterData((prev:any)=>({
            ...prev,
            actionType: label || null 
        }))
  }

  const handleStatusRequest =(valu:any)=>{

          const ID:Number = valu.id
          setFilterData((prev:any)=>({
            ...prev,
            status: ID || null
          })) 
  } 

    const handleReset = (row:any) => {
      const id:number = row.id ?? null;
      if(id){
       resetOrganogramLog(id);
      }
    };


  const handlePagination=(pageNo:number)=>{
        setFilterData((prev)=>(
            {
                ...prev,
                page:pageNo,
            }
        ))
  }
   
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev)=>({
        ...prev,
        page:pageNo,
        length:limit
    }))
  };

  const handleSerachInput=(input:any)=>{
           setFilterData((prev:any)=>({
            ...prev,
            search:input
           }))
  }


    return (
        <div className="p-2">
            <PageHeader title="Data Changes" />
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "auto",
                    marginTop: "2%",
                }}
            >
                <div
                    style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <BasicDataTable
                        search={true}
                        handleSearch={handleSerachInput}
                        Title="Organogram Log"
                        columns={dataChange(handleReset)}
                        data={DataForOrganogramLogs}
                        headerContent={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "6px",
                                    marginBottom: "15px",
                                    marginRight:'6px'
                                }}
                            >
                                {/* Status Dropdown */}
                                <RoundedDropdown
                                    options={!StatusDropDownLoading && StatusDropDownSuccess && StatusDropDown || []}
                                    onSelect={(value)=>handleStatusRequest(value)}
                                    defaultLabel="All"
                                    // width="150px"
                                    width="auto"

                                    isShowHeading
                                    DropdownHeading="Status"
                                    headingColor="#2e8dd3"
                                />
                                {/* Status Dropdown */}
                                <RoundedDropdown
                                    options={!organogramTypesLoading && organogramTypesTypes && ActionTypeDropDown || []}
                                    onSelect={(value)=>handleActionTypeRquest(value)}
                                    defaultLabel="All"
                                    // width="150px"
                                    width="auto"

                                    isShowHeading
                                    DropdownHeading="Action Type"
                                    headingColor="#2e8dd3"
                                />
                            </div>
                        }
                        onChangePage={(pageNo: number) => {
                            handlePagination(pageNo);
                          }}
                          onChangeRowsPerPage={(newPerPage: any, page: any) => {
                            handleonChangeRowsPerPage(newPerPage, page);
                          }}
                        paginationTotalRows={data?.data?.Pagination?.TotalRecords || 0}
                    />
                </div>
            </div>
        </div>
    )
}
export default DataChange